import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { CalculationType } from 'src/app/Modules/informate/enums/calculation-type.enum';
import { pipeSpecVersion } from 'src/app/Modules/settings/models/idms/pipe-specification.model';

@Component({
    selector: 'app-pipe-code-general',
    templateUrl: './pipe-code-general.component.html',
    styleUrls: ['./pipe-code-general.component.scss'],
    standalone: false
})
export class PipeCodeGeneralComponent implements OnInit {
    @Input() pipeSpecVersion: pipeSpecVersion;
    @Input() enable: boolean;
    @Input() calcType: CalculationType;
    @Output() SelectedcalculationType = new EventEmitter<string>();

    GenralInfoForm: UntypedFormGroup;
    calculationType: CalculationType;
    permitWashers: any;
    isPipeSpec: boolean = false;
    constructor(
        private formBuilder: UntypedFormBuilder,
        public route: Router,
        public jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        this.loadFormGroup();
        this.createFormControls();

        if (this.enable == true) {
            this.GenralInfoForm.disable();
        }

        this.jointCalcService.ispipeSpec.subscribe((res) => {
            if (res) this.isPipeSpec = !res;
        });
    }

    //loading formGroup
    loadFormGroup() {
        if (this.route.url == '/settings/idms') {
            this.calculationType = this.pipeSpecVersion.calculationType;
        } else {
            this.calculationType = this.calcType;
        }
    }

    //creating form control
    createFormControls() {
        this.GenralInfoForm = this.formBuilder.group({
            calculationType: [String(this.calculationType), [Validators.required]],
            permitWashers: [this.permitWashers],
        });
        this.GenralInfoForm.markAsDirty();
        this.GenralInfoForm.markAllAsTouched();
    }
}
